import api from '../api/client'

const assessoresService = {
  async listar(organizadorId, { ativo } = {}) {
    const qs = new URLSearchParams()
    if (ativo !== undefined) qs.set('ativo', ativo)
    const res = await api.get(`/organizadores/${organizadorId}/assessores?${qs}`)
    return res.data
  },

  async criar(organizadorId, data) {
    const res = await api.post(`/organizadores/${organizadorId}/assessores`, data)
    return res.data
  },

  async atualizar(organizadorId, assessorId, data) {
    const res = await api.put(`/organizadores/${organizadorId}/assessores/${assessorId}`, data)
    return res.data
  },

  async toggle(organizadorId, assessorId) {
    const res = await api.patch(`/organizadores/${organizadorId}/assessores/${assessorId}/toggle`)
    return res.data
  },

  async excluir(organizadorId, assessorId) {
    await api.delete(`/organizadores/${organizadorId}/assessores/${assessorId}`)
  },
}

export default assessoresService
